import { useSelector } from 'react-redux';
import { selectDoesUserHaveRbacPermission } from 'core/userContext/selectors';
import { PROJECT_PERMISSIONS } from 'utils/permissions';
import { WorkflowType } from 'modules/workflows/enums';
import { useUpdateWorkflowDetails } from '../../../hooks/useUpdateWorkflowDetails';

import { Workflow } from '../../../types';
import { WorkflowTitleText, StyledWorkflowTitle, WorkflowMenu } from './styled';
import { EditableStudioHeader } from '../../EditableTextInput';
import { WorkflowLiveStatusBadge } from './WorkflowLiveStatusBadge';
import { WorkflowTypeMenu } from '../WorkflowTypeMenu';

export type WorkflowTitleProps = {
  workflow: Pick<Workflow, 'id' | 'enabled' | 'name' | 'workflowType' | 'description'>;
  isPublished: boolean;
};

export const HEADER_BAR_TITLE_ID = 'header-bar-title';

export const WorkflowTitle = ({ workflow, isPublished }: WorkflowTitleProps) => {
  const { id, workflowType, description = '' } = workflow;
  const canDraftMessaging = useSelector(selectDoesUserHaveRbacPermission)(
    PROJECT_PERMISSIONS.DraftMessaging,
  );
  const updateWorkflowDetails = useUpdateWorkflowDetails();

  const handleWorkflowNameChange = (name: string) => {
    if (name !== workflow.name) {
      updateWorkflowDetails({
        workflowDetails: {
          name,
          description,
          workflowId: id,
          workflowType: workflowType as WorkflowType,
        },
      });
    }
  };

  return (
    <>
      <StyledWorkflowTitle>
        <WorkflowTitleText data-test={HEADER_BAR_TITLE_ID} $showPublishedHeader={isPublished}>
          <EditableStudioHeader
            $showPublishedHeader={isPublished}
            isEditable={canDraftMessaging}
            title={workflow.name}
            onInputSave={handleWorkflowNameChange}
            maxWidth={500}
          />
        </WorkflowTitleText>
      </StyledWorkflowTitle>
      <WorkflowMenu>
        <WorkflowLiveStatusBadge
          isWorkflowEnabled={workflow.enabled as boolean}
          workflowType={workflow.workflowType}
        />
        <WorkflowTypeMenu workflow={workflow} />
      </WorkflowMenu>
    </>
  );
};
